export * from './gfgyxk.component';